<script lang="ts" context="module">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../../common/config/constants';
  import {
    getHasSavings,
    getJoodDayBannerDetails,
    getJoodDayCredits,
    getSavedPercentVisibility,
  } from '../../../../../common/joodUtils';
  import {
    formatNumber,
    getJoodExpiredMembershipType,
    getJoodMembershipType,
    getStr,
    globalCurrencyTag,
    isDirectionRTL,
    roundToNDigits,
    type JoodMembershipType,
  } from '../../../../../common/util';
  import { ProductTilePriceGroupVariantType } from '../product-tile-main';

  const { unbxdSearchConfig, joodExpiredFlag, primeLevel } = getAppConfig();
  let userJoodMembershipType: JoodMembershipType = getJoodMembershipType();
  const expiredJoodMembershipType = getJoodExpiredMembershipType();

  const { NOPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import ProductTileJoodWalletCreditAmount from './ProductTileJoodWalletCreditAmount.svelte';

  export let algoliaProductHit;
  export let priceType: JoodMembershipType = NOPRIME;
  export let variant: ProductTilePriceGroupVariantType;
  export let isMegasaleProduct = [];
  export let backgoundOverride: JoodMembershipType = null;
  export let showWalletCredits = true;

  const discountDecimals = +unbxdSearchConfig.decimalCount;
  const isRTL = isDirectionRTL();

  if (expiredJoodMembershipType && priceType === expiredJoodMembershipType) {
    userJoodMembershipType = priceType = expiredJoodMembershipType;
  }
  $: displayPrice = algoliaProductHit?.price?.formattedValue || algoliaProductHit?.price;
  $: wasPrice = algoliaProductHit?.wasPrice || algoliaProductHit?.price?.value;
  $: savedPrice = wasPrice - displayPrice;
  $: hasSavings = getHasSavings(priceType, userJoodMembershipType, savedPrice);
  $: savedPercent = hasSavings && roundToNDigits((savedPrice * 100) / wasPrice, discountDecimals);
  $: savedPercentVisible = getSavedPercentVisibility(algoliaProductHit);
  $: megaSaleClass = priceType === NOPRIME && isMegasaleProduct?.length ? 'megasale-theme' : '';
  $: creditPoints = getJoodDayCredits(priceType, algoliaProductHit);
  $: displayPriceFormat = `<strong>${formatNumber(displayPrice)}</strong>`;
  $: middleLeftVisible = ((priceType === NOPRIME && joodExpiredFlag) || !joodExpiredFlag) && variant !== 'bundle-tile';
  $: walletCreditVisible = priceType !== NOPRIME && creditPoints > 0 && showWalletCredits;
  $: componentVisible = (displayPrice > 0 || priceType === NOPRIME) && (middleLeftVisible || walletCreditVisible);
  $: theme = getJoodDayBannerDetails(backgoundOverride || userJoodMembershipType);
</script>

{#if componentVisible}
  <section
    class="{megaSaleClass} c_product-price-jood-wallet-container c_joodwalletcard {primeLevel
      ? 'user-PRIME'
      : 'user-NOPRIME'} variant-{variant} {joodExpiredFlag ? 'expired' : ''}"
    class:rtl={isRTL}
    class:discount-applied-section={savedPercent > 0}
  >
    <section class="middle">
      {#if middleLeftVisible}
        <section class="middle-left">
          <section class="price">
            {@html getStr('jood.price.with.currency', [globalCurrencyTag, displayPriceFormat])}
            <span class="vat">{getStr('extra.addtocart.inc.of.vat')}</span>
            {#if hasSavings}
              <section class="savings">
                <span class="striked-off">{formatNumber(wasPrice)}</span>
                <strong class="orange-text">
                  {@html getStr('extra.cart.saved.amt', [globalCurrencyTag, formatNumber(savedPrice)])}
                </strong>
              </section>
            {/if}
          </section>

          {#if hasSavings && savedPercentVisible}
            <section class="save-percent-tag top-right-tag">
              {getStr('product.percentageDiscount.off', [savedPercent])}
            </section>
          {/if}
        </section>
      {/if}
      {#if walletCreditVisible}
        <ProductTileJoodWalletCreditAmount isTacticalFlag={false} {creditPoints} {variant} {priceType} {theme} />
      {/if}
    </section>
  </section>
{/if}

<style lang="scss">
  :global {
    .c_product-price-jood-wallet-container:not(.variant-pdp) {
      &.expired {
        .credits-details-left {
          .price,
          .text {
            font-size: 8px;
          }
        }
        .price-expire-card {
          font-size: 7px;
        }
      }
    }
    .jood-cart-popup {
      .c_product-price-jood-wallet-container {
        &.expired {
          .credits-details-left {
            gap: 4px;
            height: 24px;
            padding: 0.5rem 0.8rem;
            .price,
            .text {
              font-size: 16px;
              line-height: 16px;
            }
          }
          .price-expire-card {
            font-size: 1.4rem;
            line-height: 1.4rem;
          }
        }
      }
    }
  }
</style>
